import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import WorkStructure from './WorkStructure';
import WorkStructureTable from './WorkStructureTable';
import ControlAccountView from './ControlAccountView';
import {ROLE_VIEWER,STATUS_PROJECT_PUBLISHED} from '../common/redux/constantes';
import Summary from '../summary/Summary';
import Daily from '../daily/Daily';
import Completion from '../completion/Completion';
import Periods from '../periods/Periods';
import Workplan from '../workplan/Workplan';
// import Cir from '../cir/Cir';
import Status from '../status/Status';
import Actual from '../actual/Actual';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import LinearProgress from '@material-ui/core/LinearProgress';


function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    
  },
});

class TabWbsContainer extends React.Component 
{
  state = {
    value: 0,
  };

  handleChange = (event, value) => 
  {
    this.setState({ value });
  };

  componentDidMount()
  {
    this.props.actions.fetchProjectStatus(this.props.project.project)
    .then(res=>{
    });
  }


  render() 
  {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      
      <div className={classes.root}>

      {this.props.wbs.project_status>0?
        <div>
          <AppBar position="static" style={{backgroundColor:"#00796B !important"}} color="#00796B">
            <Tabs 
              value={value} 
              onChange={this.handleChange}
              indicatorColor="primary"
              variant="scrollable" >
              {
                Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED?
                (<Tab label="WBS" />)
                :null
              }
              <Tab label="WBS Table" />
              <Tab label="Control Accounts" />
              <Tab label="Costs" />
              <Tab label="BASELINE"/>
              { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED?
                <Tab label="Actual Costs"/>
                : null
              }
              { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED?
                <Tab label="Deliverables"/>
                : null
              }
              { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED?
                <Tab label="Reporting Periods"/>
                : null
              }
              { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED && false?
                <Tab label="CA in RP's"/>
                : null
              }
               { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED?
                <Tab label="Project Status"/>
                : null
              }
              { this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED?
                <Tab label="Work Plan"/>
                : null
              }
              
            </Tabs>
          </AppBar>
          {(value === 0 && Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status !==STATUS_PROJECT_PUBLISHED) && <TabContainer><WorkStructure project={this.props.project} /></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===0 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 1)) && <TabContainer><WorkStructureTable project={this.props.project} project_status={this.props.wbs.project_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===1 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 2)) && <TabContainer><ControlAccountView project={this.props.project} project_status={this.props.wbs.project_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===2 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 3)) && <TabContainer><Summary project={this.props.project.project} project_status={this.props.wbs.project_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===3 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 4)) && <TabContainer><Daily project={this.props.project.project} project_status={this.props.wbs.project_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===4 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 5)) && <TabContainer><Actual project={this.props.project.project} project_status={this.props.project.fake_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===5 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 6)) && <TabContainer><Completion project={this.props.project.project} project_status={this.props.project.fake_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===6 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 7)) && <TabContainer><Periods project={this.props.project.project} project_status={this.props.project.fake_status}/></TabContainer>}
          {/*(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===7 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 8)) && <TabContainer><Cir project={this.props.project.project} project_status={this.props.wbs.project_status}/></TabContainer>*/}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===7 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 8)) && <TabContainer><Status project={this.props.project.project} project_status={this.props.wbs.project_status}/></TabContainer>}
          {(((Number(localStorage.getItem("role")) === ROLE_VIEWER || this.props.wbs.project_status===STATUS_PROJECT_PUBLISHED) && value===8 )|| ((Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.wbs.project_status!==STATUS_PROJECT_PUBLISHED) && value === 9)) && <TabContainer><Workplan project={this.props.project.project} project_status={this.props.wbs.project_status}/></TabContainer>}
        </div>
        :<LinearProgress />
      }
        
      </div>
    );
  }
}

TabWbsContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TabWbsContainer));


// WEBPACK FOOTER //
// ./src/features/wbs/TabWbsContainer.js